export default __webpack_public_path__ + "static/media/google_play_badge.e1c7457d.png";